module.exports = __webpack_public_path__ + "img/noneSearch.6c7f0bdd.png";